<script lang="ts">
  import BrowseByContentCard from "@shared/svelte/Components/BrowseBy/BrowseByContentCard.svelte";
  import ResponsiveContainerWithHeader from "@shared/svelte/Components/ResponsiveContainerWithHeader.svelte";
  import Skeleton from "svelte-skeleton/Skeleton.svelte";
  import TrackingContext from "@shared/svelte/Components/Tracking/TrackingContext.svelte";
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";
  import { BrowseByContainerEntity } from "@shared/services/event_tracking/entities";

  import type { BrowseByContentCardDataWithAd } from "@shared/types/BrowseByContentCardData";

  export let headerText: string | null = null;
  export let forceWhiteBackground: boolean = false;
  export let pageName: string = "home"; // This is the only page name we currently support
  export let pageValue: string | null = null;
  export let mobileMode: boolean | null = null;
  mobileMode;

  let loaded = false;
  let shouldShowBrowseBy = false;
  let browseByContents: BrowseByContentCardDataWithAd[] = null;
  const options = {
    method: "GET",
    url: "/api/retailer/browse_by_placements/browse_by_placements",
    data: {
      page_name: pageName,
      page_value: pageValue,
    },
  };

  HttpPromise(options).then(res => {
    loaded = true;
    browseByContents = res;
    if (res?.length) {
      shouldShowBrowseBy = true;
    }
  });

  const useWhiteBackground: boolean = forceWhiteBackground || pageName !== "home";

  const layoutPosition: string = "on_page";

  const trackingParams: BrowseByContainerEntity = new BrowseByContainerEntity({
    header_text: headerText,
    layout_position: layoutPosition,
  });

  // If the stateParams that currently exist don't overlap with forwardStateParams,
  // then the new params will just get appended, creating filters that result in no products.
  // For example, if on type=1&category=2 and a popular category for tagId=3&tagName=foo is clicked,
  // without flushing here, the user would be taken to type=1&category=2&tagId=3&tagName=foo
  const flushedForwardStateParams = (forwardStateParams: any) => {
    return {
      type: forwardStateParams.type || null,
      tagId: forwardStateParams.tagId || null,
      tagName: forwardStateParams.tagName || null,
      category: forwardStateParams.category || null,
      subcategory: forwardStateParams.subcategory || null,
    };
  };
</script>

{#if !loaded}
  <div class="fizz-styles" data-testid="browse-by-loading">
    <ResponsiveContainerWithHeader {headerText} {useWhiteBackground}>
      {#each Array(5) as _}
        <div class="fizz-stack-24">
          <Skeleton animate={true} height={140} width={240}>
            <circle cx="70" cy="70" r="70" />
          </Skeleton>
        </div>
      {/each}
    </ResponsiveContainerWithHeader>
  </div>
{:else if shouldShowBrowseBy}
  <TrackingContext entities={trackingParams}>
    <div data-testid="browse-by">
      <ResponsiveContainerWithHeader {headerText} {useWhiteBackground}>
        {#each browseByContents as card}
          <BrowseByContentCard
            contentClass={card.content_class}
            contentValueId={card.content_value_id}
            contentValueName={card.content_value_name}
            forwardStateParams={flushedForwardStateParams(card.forward_state_params)}
            imageAltText={card?.image_alt_text || card.content_value_name}
            imageUrl={card.image_url}
            browseByAdTrackingValues={card?.paid_tracking_values}
            {layoutPosition}
          />
        {/each}
      </ResponsiveContainerWithHeader>
    </div>
  </TrackingContext>
{/if}
